const Style = {

  user: 'absolute top-1/2 -translate-y-2/4 right-3 z-10',
  name: 'float-right opacity-50 text-xs font-normal',

} 

export default Style;